import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=759e6986&scoped=true&"
import script from "./Brands.vue?vue&type=script&lang=ts&"
export * from "./Brands.vue?vue&type=script&lang=ts&"
import style0 from "./Brands.vue?vue&type=style&index=0&id=759e6986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759e6986",
  null
  
)

export default component.exports